import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel"]

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    const reviewId = event.currentTarget.dataset.reviewId
    const modal = document.getElementById(`review-modal-${reviewId}`)
    if (!modal) return

    modal.classList.remove("hidden")
    requestAnimationFrame(() => {
      modal.querySelector("[data-review-modal-target='overlay']")?.classList.add("opacity-100")
      modal.querySelector("[data-review-modal-target='panel']")?.classList.add("opacity-100", "scale-100")
      modal.querySelector("[data-review-modal-target='panel']")?.classList.remove("opacity-0", "scale-95")
    })
    document.body.style.overflow = "hidden"
  }

  close() {
    const modal = this.element
    const overlay = modal.querySelector("[data-review-modal-target='overlay']")
    const panel = modal.querySelector("[data-review-modal-target='panel']")

    overlay?.classList.remove("opacity-100")
    panel?.classList.remove("opacity-100", "scale-100")
    panel?.classList.add("opacity-0", "scale-95")

    setTimeout(() => {
      modal.classList.add("hidden")
      document.body.style.overflow = ""
    }, 200)
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.element.classList.contains("hidden")) {
      this.close()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
